import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CTAButtonProps = {
  label: string;
  note?: string;
  id?: string;
  className?: string;
};
export function CTAButton({
  label,
  note,
  id,
  className = ''
}: CTAButtonProps) {
  return <div className={`w-full flex flex-col items-center ${className}`} data-id="element-73" data-mp="2fzv031ajki33">
      <a id={id} href={CHECKOUT_URL} className="cta-pulse group w-full max-w-xl inline-flex items-center justify-center gap-2 rounded-2xl bg-gold px-5 py-4 text-center text-base sm:text-lg font-extrabold uppercase tracking-wide text-navy-deep transition-colors hover:bg-gold-light focus:outline-none focus-visible:ring-4 focus-visible:ring-gold/40" data-id="element-74" data-mp="2g1o8al0szad7">
        <span className="leading-snug" data-id="element-75" data-mp="2yql2yq0444vy">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform group-hover:translate-x-1" aria-hidden="true" data-id="element-76" data-mp="3cpceq5ri5egx" />
      </a>
      {note && <p className="mt-3 text-center text-xs sm:text-sm text-navy/60" data-id="element-77" data-mp="38mfts8ehp69t">{note}</p>}
    </div>;
}